import { Component, EventEmitter, OnDestroy, OnInit, Output, Input } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EMPTY, Observable, of, Subscription, timer } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, tap, timeout } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

import ValidationRegistro from '../../validators/registro.validators';
import { AuthService } from 'src/app/services/auth/auth.service';
import { AdministrarUsuariosService } from 'src/app/services/administracion-usuarios/administrar-usuarios.service';
import {
  IResponseValidaContrasena,
  Validacion
} from 'src/app/models/administracion-usuarios/administracion-usuarios.model';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { RegistroInformativoDialogComponent } from '../dialogs/registro-informativo-dialog/registro-informativo-dialog.component';
import { Store } from '@ngrx/store';

import { INormaModelInput, IResponseModel } from 'src/app/models/seguros-atlas/atlas.model';
import { AppState } from 'src/app/@store/app.reducers';
import { ActivarLoadingAction, DesactivarLoadingAction } from 'src/app/@store/actions';
import { RegistroValidadorDosFaComponent } from '../dialogs/registro-validador-dos-fa/registro-validador-dos-fa.component';
import { BLOCK_UI_REQUEST } from 'src/app/helper/seguros-atlas/seguros-atlas.helper';
import { MatIcon } from '@angular/material/icon';


interface CatalogoPregunta {
  Text: string;
  Value: string | number;
}

interface LadaTelefonicaInternacionalResponse {
  valor_dato: number | string;
  descripl_dato: string;
}

interface CodigoPaisTelefono {
  codigo: string;
  pais: string;
  bandera: string;
}

type ResultadoValidacionUsuario =
  | { estado: 'valido' }
  | { estado: 'errorUsuario'; error: any }
  | { estado: 'errorSisa'; error: any };

type ContactoControlName = 'Email' | 'Telefono';
export type TipoRegistroAgente = 'Ag' | 'AgUdi';

interface RegistroAgenteConfig {
  perfilNombre: string;
  etiquetaCuenta: string;
  placeholderCuenta: string;
}

const REGISTRO_AGENTE_CONFIG: Record<
  TipoRegistroAgente,
  RegistroAgenteConfig
> = {
  Ag: {
    perfilNombre: 'Agente',
    etiquetaCuenta: 'Clave Agente',
    placeholderCuenta: 'Ingresa tu clave'
  },
  AgUdi: {
    perfilNombre: 'Agente UDI',
    etiquetaCuenta: 'Clave Agente UDI',
    placeholderCuenta: 'Ingresa tu clave UDI'
  }
};

const NORMA_DOS_FA_CORREO: INormaModelInput = {
  NumNorma: 763,
  Parametro1: 1,
  Parametro2: 0,
  Parametro3: 0
};

const NORMA_DOS_FA_TELEFONO: INormaModelInput = {
  NumNorma: 765,
  Parametro1: 1,
  Parametro2: 0,
  Parametro3: 0
};

@Component({
    selector: 'app-registro-agente-form',
    templateUrl: './registro-agente-form.component.html',
    styleUrls: ['./registro-agente-form.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatIcon]
})
export class RegistroAgenteFormComponent implements OnInit, OnDestroy {
  @Input() tipoRegistro: TipoRegistroAgente = 'Ag';
  @Output() regresarPerfil = new EventEmitter<void>();
  @Output() registroCompletado = new EventEmitter<string>();
  @Output() formularioModificado = new EventEmitter<boolean>();

  hidePassword = true;
  hideConfirmPassword = true;

  get configuracionRegistro(): RegistroAgenteConfig {
    return REGISTRO_AGENTE_CONFIG[this.tipoRegistro];
  }

  todoFormulario = new FormGroup({
    NIP: new FormControl('', Validators.required),
    Usuario: new FormControl('', [
      Validators.required,
      Validators.pattern(/^[a-zA-Z0-9_]*$/),
      Validators.minLength(4),
      Validators.maxLength(8)
    ]),
    Password: new FormControl('', Validators.required),
    ConfirmaPassword: new FormControl('', Validators.required),
    Alias: new FormControl('', Validators.required),
    Cuenta: new FormControl(null, [
      Validators.required,
      Validators.pattern('^[0-9]*$')
    ]),
    Email: new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.pattern('[^@]+@[^@]+\\.[a-zA-Z]{2,}$')
    ]),
    Telefono: new FormControl(null, [
      Validators.required,
      Validators.pattern('^[0-9]{11,13}$')
    ]),
    CodEmail: new FormControl(null),
    CodTelefono: new FormControl(null),
    IdPregunta: new FormControl(0, Validators.required),
    Respuesta: new FormControl('', Validators.required),
    Nombre: new FormControl('', Validators.required),
    Paterno: new FormControl('', Validators.required),
    Materno: new FormControl('', Validators.required),
    RFC: new FormControl('', [
      Validators.required,
      Validators.pattern(
        '^([A-Za-zÑñ\\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))([A-Za-z0-9]{3})?$'
      ),
      Validators.maxLength(13)
    ]),
    ValidarUsuario: new FormControl('false', Validators.required)
  }, {
    validators: ValidationRegistro.match('Password', 'ConfirmaPassword')
  });

  validandoCorreo = false;
  validandoTelefono = false;
  dosFaCorreoHabilitado = true;
  dosFaTelefonoHabilitado = true;
  consultandoNormaCorreo = true;
  consultandoNormaTelefono = true;
  private normaCorreoConsultada = false;
  private normaTelefonoConsultada = false;
  codigosPaisTelefono: CodigoPaisTelefono[] = [
    { codigo: '52', pais: 'México', bandera: 'MX' }
  ];

  codigoPaisTelefonoSeleccionado: CodigoPaisTelefono = this.codigosPaisTelefono[0];
  telefonoLocal = '';

  procesandoCorreo = false;
  procesandoTelefono = false;
  twoFaCorreoAbierto = false;
  twoFaTelefonoAbierto = false;
  loadingRegistro = false;
  errorUsuarioContacto: Record<ContactoControlName, string> = {
    Email: '',
    Telefono: ''
  };
  emailValidado = '';
  telefonoValidado = '';
  actualizarUsuario = 'false';
  private restaurandoContacto = false;

  validandoPassword = false;
  passwordValido = false;
  generaErrorPasswordForm = false;
  passwordValidaciones: string[] = [];

  usuarioValido = {
    is: false,
    pending: false
  };

  validacionUsuario = '';
  catPreguntas: CatalogoPregunta[] = [];

  private readonly subscriptions = new Subscription();

  constructor(
    private readonly authService: AuthService,
    private readonly adminService: AdministrarUsuariosService,
    private readonly snackBar: MatSnackBar,
    private readonly dialog: MatDialog,
    private readonly store: Store<AppState>
  ) {}

  ngOnInit(): void {
    this.cargarConfiguracionDosFa();
    this.cargarCatalogoPreguntas();
    this.cargarLadasTelefonicasInternacionales();
    this.configurarValidacionUsuario();
    this.configurarValidacionPassword();
    this.configurarSincronizacionConfirmacionPassword();
    this.configurarResetValidacionContacto();
    this.subscriptions.add(
      this.todoFormulario.valueChanges.subscribe(() => {
        this.formularioModificado.emit(
          this.todoFormulario.dirty
        );
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  regresar(): void {
    this.regresarPerfil.emit();
  }

  private cargarConfiguracionDosFa(): void {
    this.consultarConfiguracionDosFaCorreo();
    this.consultarConfiguracionDosFaTelefono();
  }

  private consultarConfiguracionDosFaCorreo(): void {
    this.consultandoNormaCorreo = true;

    const consulta = this.authService
      .obtenerNormaAtlas({ ...NORMA_DOS_FA_CORREO })
      .subscribe({
        next: (res: IResponseModel) => {
          this.consultandoNormaCorreo = false;
          this.aplicarConfiguracionDosFaCorreo(res);
        },
        error: () => {
          this.consultandoNormaCorreo = false;
          this.normaCorreoConsultada = false;
          this.dosFaCorreoHabilitado = true;
        }
      });

    this.subscriptions.add(consulta);
  }

  private consultarConfiguracionDosFaTelefono(): void {
    this.consultandoNormaTelefono = true;

    const consulta = this.authService
      .obtenerNormaAtlas({ ...NORMA_DOS_FA_TELEFONO })
      .subscribe({
        next: (res: IResponseModel) => {
          this.consultandoNormaTelefono = false;
          this.aplicarConfiguracionDosFaTelefono(res);
        },
        error: () => {
          this.consultandoNormaTelefono = false;
          this.normaTelefonoConsultada = false;
          this.dosFaTelefonoHabilitado = true;
        }
      });

    this.subscriptions.add(consulta);
  }

  private aplicarConfiguracionDosFaCorreo(res: IResponseModel): void {
    this.normaCorreoConsultada = true;
    this.dosFaCorreoHabilitado = res?.Respuesta?.Status == 1;

    if (!this.dosFaCorreoHabilitado) {
      this.todoFormulario.get('CodEmail')?.setValue('9000');
      this.validandoCorreo = false;
      this.emailValidado = '';
      return;
    }

    if (this.todoFormulario.get('CodEmail')?.value === '9000') {
      this.todoFormulario.get('CodEmail')?.setValue('');
    }
  }

  private aplicarConfiguracionDosFaTelefono(res: IResponseModel): void {
    this.normaTelefonoConsultada = true;
    this.dosFaTelefonoHabilitado = res?.Respuesta?.Status == 1;

    if (!this.dosFaTelefonoHabilitado) {
      this.todoFormulario.get('CodTelefono')?.setValue('9000');
      this.validandoTelefono = false;
      this.telefonoValidado = '';
      return;
    }

    if (this.todoFormulario.get('CodTelefono')?.value === '9000') {
      this.todoFormulario.get('CodTelefono')?.setValue('');
    }
  }

  continuar(): void {
    this.todoFormulario.markAllAsTouched();

    if (!this.usuarioValido.is) {
      const usuarioControl = this.todoFormulario.get('Usuario');

      usuarioControl?.setErrors({
        ...(usuarioControl.errors || {}),
        customError: true
      });

      this.validacionUsuario = this.validacionUsuario || 'Debe ingresar un usuario válido.';
    }

    const erroresRegistro = this.obtenerErroresRegistro();

    if (erroresRegistro.length) {
      this.mostrarErroresRegistro(erroresRegistro);
      return;
    }

    this.registrarAgente();
  }

  private cargarLadasTelefonicasInternacionales(): void {
    BLOCK_UI_REQUEST.Run(
      this.store,
      this.authService.obtenerLadasTelefonicasInternacionales(),
      (respuesta: any) => {
        const ladas = Array.isArray(respuesta?.Respuesta)
          ? respuesta.Respuesta
          : [];

        const codigosPais = ladas
          .filter((item: LadaTelefonicaInternacionalResponse) =>
            item?.valor_dato !== null &&
            item?.valor_dato !== undefined &&
            !!item?.descripl_dato
          )
          .map((item: LadaTelefonicaInternacionalResponse) => ({
            codigo: `${item.valor_dato}`.trim(),
            pais: `${item.descripl_dato}`.trim(),
            bandera: this.obtenerClavePais(`${item.descripl_dato}`)
          }));

        if (!codigosPais.length) {
          this.seleccionarMexicoComoLadaInicial();
          return;
        }

        this.codigosPaisTelefono = this.ordenarLadasTelefono(codigosPais);
        this.seleccionarMexicoComoLadaInicial();
        this.sincronizarTelefonoCompleto(false);
      }
    );
  }

  private ordenarLadasTelefono(ladas: CodigoPaisTelefono[]): CodigoPaisTelefono[] {
    return [...ladas].sort((a, b) => {
      if (this.esMexicoLada(a)) {
        return -1;
      }

      if (this.esMexicoLada(b)) {
        return 1;
      }

      return this.normalizarTexto(a.pais).localeCompare(this.normalizarTexto(b.pais));
    });
  }

  private esMexicoLada(lada: CodigoPaisTelefono): boolean {
    return lada.codigo === '52' || this.normalizarTexto(lada.pais) === 'mexico';
  }

  private seleccionarMexicoComoLadaInicial(): void {
    const mexico = this.codigosPaisTelefono.find(item => this.esMexicoLada(item));

    this.codigoPaisTelefonoSeleccionado = mexico || this.codigosPaisTelefono[0];
  }

  private obtenerErroresRegistro(): string[] {
    const errores: string[] = [];

    errores.push(...this.obtenerErroresFormulario());

    if (this.usuarioValido.pending) {
      errores.push('Usuario: La validación del usuario aún está en proceso.');
    }

    if (!this.usuarioValido.is) {
      errores.push(`Usuario: ${this.validacionUsuario || 'Debe ingresar un usuario válido.'}`);
    }

    if (this.validandoPassword) {
      errores.push('Contraseña: La validación de contraseña aún está en proceso.');
    }

    if (this.generaErrorPasswordForm || !this.passwordValido) {
      const passwordControl = this.todoFormulario.get('Password');

      if (passwordControl?.value) {
        errores.push('Contraseña: La contraseña tiene un formato incorrecto.');
      }
    }

    if (this.consultandoNormaCorreo) {
      errores.push('Email: La configuración de verificación aún está en proceso.');
    } else if (this.dosFaCorreoHabilitado && !this.validandoCorreo) {
      errores.push('Email: El email no está validado.');
    }

    if (this.consultandoNormaTelefono) {
      errores.push('Teléfono celular: La configuración de verificación aún está en proceso.');
    } else if (this.dosFaTelefonoHabilitado && !this.validandoTelefono) {
      errores.push('Teléfono celular: El teléfono celular no está validado.');
    }

    return this.obtenerErroresUnicos(errores);
  }

  private obtenerErroresFormulario(): string[] {
    const errores: string[] = [];

    Object.keys(this.todoFormulario.controls).forEach((controlName) => {
      if (['CodEmail', 'CodTelefono', 'ValidarUsuario'].includes(controlName)) {
        return;
      }

      const control = this.todoFormulario.get(controlName);

      if (!control) {
        return;
      }

      if (controlName === 'IdPregunta' && Number(control.value) === 0) {
        control.setErrors({
          ...(control.errors || {}),
          required: true
        });
      }

      if (!control.errors) {
        return;
      }

      const mensaje = this.obtenerMensajeErrorControl(controlName);

      if (mensaje) {
        errores.push(`${this.obtenerEtiquetaControl(controlName)}: ${mensaje}`);
      }
    });

    return errores;
  }

  private obtenerMensajeErrorControl(controlName: string): string {
    const control = this.todoFormulario.get(controlName);

    if (!control || !control.errors) {
      return '';
    }

    if (control.hasError('required')) {
      return 'El campo es obligatorio.';
    }

    if (control.hasError('telefonoLocalIncompleto')) {
      return 'Ingresa los 10 dígitos del teléfono.';
    }

    if (control.hasError('email')) {
      return 'El correo no tiene un formato válido.';
    }

    if (control.hasError('pattern')) {
      return this.getPatternError(controlName);
    }

    if (control.hasError('minlength') || control.hasError('minlengthCustom')) {
      return 'El valor es demasiado corto.';
    }

    if (control.hasError('maxlength') || control.hasError('maxlengthCustom')) {
      return 'El valor excede la longitud permitida.';
    }

    if (control.hasError('exists') || control.hasError('customError')) {
      return this.validacionUsuario || 'El usuario no es válido.';
    }

    if (control.hasError('formatoIncorrecto')) {
      return 'La contraseña tiene un formato incorrecto.';
    }

    if (control.hasError('match')) {
      return 'Las contraseñas no coinciden.';
    }

    return 'El campo no es válido.';
  }

  private obtenerEtiquetaControl(controlName: string): string {
    const etiquetas: { [key: string]: string } = {
      NIP: 'NIP',
      Usuario: 'Usuario',
      Password: 'Contraseña',
      ConfirmaPassword: 'Confirma contraseña',
      Alias: 'Alias o sobrenombre',
      Cuenta: 'Clave Agente',
      Email: 'Email',
      Telefono: 'Teléfono celular',
      IdPregunta: 'Pregunta secreta',
      Respuesta: 'Respuesta',
      Nombre: 'Nombre',
      Paterno: 'Apellido paterno',
      Materno: 'Apellido materno',
      RFC: 'RFC'
    };

    return etiquetas[controlName] || controlName;
  }

  private obtenerErroresUnicos(errores: string[]): string[] {
    return errores.filter((error, index, arreglo) => arreglo.indexOf(error) === index);
  }

  private mostrarErroresRegistro(errores: string[]): void {
    this.dialog.open(RegistroInformativoDialogComponent, {
      width: '520px',
      maxWidth: 'calc(100vw - 32px)',
      autoFocus: false,
      data: {
        type: 'error',
        icon: 'error_outline',
        title: 'Revisa la información',
        message: 'No fue posible continuar con el registro. Corrige lo siguiente:',
        messages: errores,
        actionText: 'Entendido'
      }
    });
  }

  desbloquearAutofill(event: FocusEvent): void {
    const input = event.target as HTMLInputElement;

    setTimeout(() => {
      input.readOnly = false;
    }, 80);
  }

  bloquearAutofill(event: FocusEvent): void {
    const input = event.target as HTMLInputElement;

    input.readOnly = true;
  }

  private ejecutarRegistro(): Observable<unknown> {
    const payload = this.todoFormulario.getRawValue();

    return this.tipoRegistro === 'AgUdi'
      ? this.authService.registrarAgenteUdi(payload)
      : this.authService.registrarAgente(payload);
  }

  private registrarAgente(): void {
    if (this.loadingRegistro) {
      return;
    }

    this.todoFormulario
      .get('ValidarUsuario')
      ?.setValue(this.actualizarUsuario);

    this.loadingRegistro = true;
    this.store.dispatch(ActivarLoadingAction());

    this.ejecutarRegistro().subscribe({
      next: () => {
        this.loadingRegistro = false;
        this.store.dispatch(DesactivarLoadingAction());

        const usuario = `${this.todoFormulario.get('Usuario')?.value || ''}`;

        this.registroCompletado.emit(usuario);
      },
      error: err => {
        this.loadingRegistro = false;
        this.store.dispatch(DesactivarLoadingAction());

        this.abrirDialogoInformativo(
          'error',
          'Error al registrar',
          this.obtenerMensajeErrorRegistro(err)
        );
      }
    });
  }

  mostrarErrorUsuarioContacto(controlName: ContactoControlName): boolean {
    const control = this.todoFormulario.get(controlName);

    return !!this.errorUsuarioContacto[controlName]
      && !!control?.value
      && control.valid
      && !this.usuarioValido.is;
  }

  getErrorUsuarioContacto(controlName: ContactoControlName): string {
    return this.errorUsuarioContacto[controlName];
  }

  private validarUsuarioParaContacto(
    controlName: ContactoControlName,
    mostrarDialogo = false
  ): boolean {
    const usuarioControl = this.todoFormulario.get('Usuario');
    const usuario = `${usuarioControl?.value || ''}`.trim();

    if (this.usuarioValido.is && !this.usuarioValido.pending) {
      this.limpiarErrorUsuarioContacto(controlName);
      return true;
    }

    const mensaje = !usuario
      ? 'Primero ingresa un usuario para poder verificar email o teléfono.'
      : this.usuarioValido.pending
        ? 'Espera a que termine la validación del usuario para verificar email o teléfono.'
        : 'Primero ingresa un usuario válido para poder verificar email o teléfono.';

    this.errorUsuarioContacto[controlName] = mensaje;
    usuarioControl?.markAsTouched();

    if (!usuario) {
      usuarioControl?.setErrors({
        ...(usuarioControl.errors || {}),
        required: true
      });
    }

    if (mostrarDialogo) {
      this.abrirDialogoInformativo(
        'warning',
        'Usuario requerido',
        mensaje
      );
    }

    return false;
  }

  private limpiarErrorUsuarioContacto(controlName?: ContactoControlName): void {
    if (controlName) {
      this.errorUsuarioContacto[controlName] = '';
      return;
    }

    this.errorUsuarioContacto.Email = '';
    this.errorUsuarioContacto.Telefono = '';
  }

  private obtenerMensajeErrorRegistro(err: any): string {
    if (err?.error?.Message) {
      return err.error.Message;
    }

    if (Array.isArray(err?.error)) {
      const errores = err.error
        .map((item: any) => item?.Exception || item?.Message || item?.message)
        .filter(Boolean);

      if (errores.length) {
        return errores.join('<br>');
      }
    }

    if (err?.error?.Exception) {
      return err.error.Exception;
    }

    if (typeof err?.error === 'string') {
      return err.error;
    }

    return 'No fue posible registrar el usuario. Intenta nuevamente.';
  }

  verificarCorreo(): void {
    if (
      !this.dosFaCorreoHabilitado ||
      this.consultandoNormaCorreo ||
      this.validandoCorreo ||
      this.procesandoCorreo ||
      this.twoFaCorreoAbierto
    ) {
      return;
    }

    const emailControl = this.todoFormulario.get('Email');

    emailControl?.markAsTouched();

    if (!emailControl?.valid) {
      return;
    }

    if (!this.validarUsuarioParaContacto('Email', true)) {
      return;
    }

    if (this.normaCorreoConsultada) {
      this.abrirValidadorDosFaCorreo();
      return;
    }

    this.validandoCorreo = false;
    this.procesandoCorreo = true;
    this.store.dispatch(ActivarLoadingAction());

    this.authService.obtenerNormaAtlas({ ...NORMA_DOS_FA_CORREO }).subscribe({
      next: (res: IResponseModel) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.procesandoCorreo = false;
        this.aplicarConfiguracionDosFaCorreo(res);

        if (this.dosFaCorreoHabilitado) {
          this.abrirValidadorDosFaCorreo();
        }
      },
      error: () => {
        this.store.dispatch(DesactivarLoadingAction());
        this.procesandoCorreo = false;
        this.normaCorreoConsultada = false;
        this.dosFaCorreoHabilitado = true;
        this.reiniciarValidacionCorreo();

        this.abrirDialogoInformativo(
          'error',
          'Error al registrar',
          'Intenta solicitar tu código más tarde.'
        );
      }
    });
  }

  verificarCorreoAlPerderFoco(): void {
    const emailControl = this.todoFormulario.get('Email');

    emailControl?.markAsTouched();

    if (!this.dosFaCorreoHabilitado || this.consultandoNormaCorreo) {
      this.limpiarErrorUsuarioContacto('Email');
      return;
    }

    if (
      this.validandoCorreo ||
      this.procesandoCorreo ||
      !emailControl?.valid
    ) {
      this.limpiarErrorUsuarioContacto('Email');
      return;
    }

    if (!this.validarUsuarioParaContacto('Email', false)) {
      return;
    }

    this.verificarCorreo();
  }

  verificarTelefonoAlPerderFoco(): void {
    this.sincronizarTelefonoCompleto(true);

    if (!this.dosFaTelefonoHabilitado || this.consultandoNormaTelefono) {
      this.limpiarErrorUsuarioContacto('Telefono');
      return;
    }

    if (!this.telefonoTieneFormatoCorrecto()) {
      this.limpiarErrorUsuarioContacto('Telefono');
      return;
    }

    if (!this.validarUsuarioParaContacto('Telefono', false)) {
      return;
    }

    this.verificarTelefono();
  }

  telefonoTieneFormatoCorrecto(): boolean {
    const telefonoControl = this.todoFormulario.get('Telefono');

    return this.telefonoLocal.length === 10
      && !!this.codigoPaisTelefonoSeleccionado?.codigo
      && !!telefonoControl?.valid;
  }

  telefonoPuedeVerificarse(): boolean {
    return this.dosFaTelefonoHabilitado
      && !this.consultandoNormaTelefono
      && this.telefonoTieneFormatoCorrecto()
      && !this.validandoTelefono
      && !this.procesandoTelefono;
  }
  seleccionarCodigoPaisTelefono(event: Event): void {
    const select = event.target as HTMLSelectElement;
    const codigoPais = this.codigosPaisTelefono.find(
      item => this.getCodigoPaisTelefonoKey(item) === select.value
    );

    if (!codigoPais) {
      return;
    }

    this.codigoPaisTelefonoSeleccionado = codigoPais;
    this.sincronizarTelefonoCompleto(true);
  }

  capturarTelefonoLocal(event: Event): void {
    const input = event.target as HTMLInputElement;
    const valor = input.value
      .replace(/\D/g, '')
      .slice(0, 10);

    input.value = valor;
    this.telefonoLocal = valor;

    this.sincronizarTelefonoCompleto(true);
  }

  verificarTelefono(): void {
    if (
      !this.dosFaTelefonoHabilitado ||
      this.consultandoNormaTelefono ||
      this.validandoTelefono ||
      this.procesandoTelefono ||
      this.twoFaTelefonoAbierto
    ) {
      return;
    }

    const telefonoControl = this.todoFormulario.get('Telefono');

    telefonoControl?.markAsTouched();

    if (!telefonoControl?.valid) {
      return;
    }

    if (!this.validarUsuarioParaContacto('Telefono', true)) {
      return;
    }

    if (this.normaTelefonoConsultada) {
      this.abrirValidadorDosFaTelefono();
      return;
    }

    this.validandoTelefono = false;
    this.procesandoTelefono = true;
    this.store.dispatch(ActivarLoadingAction());

    this.authService.obtenerNormaAtlas({ ...NORMA_DOS_FA_TELEFONO }).subscribe({
      next: (res: IResponseModel) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.procesandoTelefono = false;
        this.aplicarConfiguracionDosFaTelefono(res);

        if (this.dosFaTelefonoHabilitado) {
          this.abrirValidadorDosFaTelefono();
        }
      },
      error: () => {
        this.store.dispatch(DesactivarLoadingAction());
        this.procesandoTelefono = false;
        this.normaTelefonoConsultada = false;
        this.dosFaTelefonoHabilitado = true;
        this.reiniciarValidacionTelefono();

        this.abrirDialogoInformativo(
          'error',
          'Error al registrar',
          'Intenta solicitar tu código más tarde.'
        );
      }
    });
  }

  isInvalid(controlName: string): boolean {
    const control = this.getControl(controlName);

    return !!control && control.invalid && (control.touched || control.dirty);
  }

  private abrirValidadorDosFaCorreo(): void {
    if (this.twoFaCorreoAbierto) {
      return;
    }

    this.twoFaCorreoAbierto = true;
    const configModal: MatDialogConfig<any> = {
      autoFocus: false,
      disableClose: true,
      width: '520px',
      maxWidth: 'calc(100vw - 32px)',
      panelClass: 'registro-twofa-dialog-panel',
      data: {
        tipo: 'Correo Electronico',
        valor: this.todoFormulario.get('Email')?.value,
        usuario: this.todoFormulario.get('Usuario')?.value
      }
    };

    const dialogRef = this.dialog
      .open(RegistroValidadorDosFaComponent, configModal)
      .afterClosed()
      .subscribe((result: any) => {
        this.twoFaCorreoAbierto = false;
        const codigo = result?.TwoFactorCode || '';

        if (codigo) {
          this.marcarCorreoValidado(codigo);
          return;
        }

        this.reiniciarValidacionCorreo();
      });

    this.subscriptions.add(dialogRef);
  }

  private abrirValidadorDosFaTelefono(): void {
    if (this.twoFaTelefonoAbierto) {
      return;
    }

    this.twoFaTelefonoAbierto = true;
    const configModal: MatDialogConfig<any> = {
      autoFocus: false,
      disableClose: true,
      width: '520px',
      maxWidth: 'calc(100vw - 32px)',
      panelClass: 'registro-twofa-dialog-panel',
      data: {
        tipo: 'Telefono',
        valor: this.todoFormulario.get('Telefono')?.value,
        usuario: this.todoFormulario.get('Usuario')?.value
      }
    };

    const dialogRef = this.dialog
      .open(RegistroValidadorDosFaComponent, configModal)
      .afterClosed()
      .subscribe((result: any) => {
        this.twoFaTelefonoAbierto = false;
        const codigo = result?.TwoFactorCode || '';

        if (codigo) {
          this.marcarTelefonoValidado(codigo);
          return;
        }

        this.reiniciarValidacionTelefono();
      });

    this.subscriptions.add(dialogRef);
  }

  private marcarCorreoValidado(codigo: string): void {
    this.todoFormulario.get('CodEmail')?.setValue(codigo);
    this.validandoCorreo = true;
    this.emailValidado = `${this.todoFormulario.get('Email')?.value || ''}`;

    if (this.validandoTelefono) {
      this.actualizarUsuario = 'false';
    }
  }

  private marcarTelefonoValidado(codigo: string): void {
    this.todoFormulario.get('CodTelefono')?.setValue(codigo);
    this.validandoTelefono = true;
    this.telefonoValidado = `${this.todoFormulario.get('Telefono')?.value || ''}`;
    this.sincronizarTelefonoVisualDesdeCompleto(this.telefonoValidado);

    if (this.validandoCorreo) {
      this.actualizarUsuario = 'false';
    }
  }

  private reiniciarValidacionCorreo(): void {
    this.todoFormulario.get('CodEmail')?.setValue(
      this.dosFaCorreoHabilitado ? '' : '9000'
    );
    this.validandoCorreo = false;
    this.emailValidado = '';
  }

  private reiniciarValidacionTelefono(): void {
    this.todoFormulario.get('CodTelefono')?.setValue(
      this.dosFaTelefonoHabilitado ? '' : '9000'
    );
    this.validandoTelefono = false;
    this.telefonoValidado = '';
  }

  private sincronizarTelefonoCompleto(markTouched = false): void {
    const telefonoControl = this.todoFormulario.get('Telefono');

    if (!telefonoControl) {
      return;
    }

    const telefonoCompleto = this.telefonoLocal
      ? `${this.codigoPaisTelefonoSeleccionado.codigo}${this.telefonoLocal}`
      : '';

    telefonoControl.setValue(telefonoCompleto, {
      emitEvent: true
    });

    if (markTouched) {
      telefonoControl.markAsDirty();
      telefonoControl.markAsTouched();
    }

    telefonoControl.updateValueAndValidity({
      onlySelf: true,
      emitEvent: false
    });

    if (markTouched && this.telefonoLocal && this.telefonoLocal.length !== 10) {
      telefonoControl.setErrors({
        ...(telefonoControl.errors || {}),
        telefonoLocalIncompleto: true
      });
    }
  }

  private sincronizarTelefonoVisualDesdeCompleto(telefonoCompleto: string): void {
    const valor = `${telefonoCompleto || ''}`.replace(/\D/g, '');

    if (!valor) {
      this.codigoPaisTelefonoSeleccionado = this.codigosPaisTelefono[0];
      this.telefonoLocal = '';
      return;
    }

    const codigoEncontrado = [...this.codigosPaisTelefono]
      .sort((a, b) => b.codigo.length - a.codigo.length)
      .find(item => valor.startsWith(item.codigo));

    this.codigoPaisTelefonoSeleccionado = codigoEncontrado || this.codigosPaisTelefono[0];

    this.telefonoLocal = valor
      .slice(this.codigoPaisTelefonoSeleccionado.codigo.length)
      .slice(0, 10);
  }

  private configurarResetValidacionContacto(): void {
    const emailControl = this.todoFormulario.get('Email');
    const telefonoControl = this.todoFormulario.get('Telefono');

    if (emailControl) {
      this.subscriptions.add(
        emailControl.valueChanges
          .pipe(distinctUntilChanged())
          .subscribe((email: string) => {
            if (this.restaurandoContacto) {
              return;
            }

            const emailActual = `${email || ''}`;

            if (this.validandoCorreo && emailActual !== this.emailValidado) {
              this.confirmarCambioEmail(emailActual);
            }
          })
      );
    }

    if (telefonoControl) {
      this.subscriptions.add(
        telefonoControl.valueChanges
          .pipe(distinctUntilChanged())
          .subscribe((telefono: string) => {
            if (this.restaurandoContacto) {
              return;
            }

            const telefonoActual = `${telefono || ''}`;

            if (this.validandoTelefono && telefonoActual !== this.telefonoValidado) {
              this.confirmarCambioTelefono(telefonoActual);
            }
          })
      );
    }
  }

  private confirmarCambioEmail(nuevoEmail: string): void {
    this.dialog.open(RegistroInformativoDialogComponent, {
      width: '420px',
      maxWidth: 'calc(100vw - 32px)',
      autoFocus: false,
      data: {
        type: 'warning',
        icon: 'error_outline',
        title: 'Cambiar email',
        message: 'Si cambias el email tendrás que validarlo nuevamente. ¿Deseas continuar?',
        showCancelButton: true,
        confirmText: 'Continuar',
        cancelText: 'Cancelar'
      }
    }).afterClosed().subscribe((confirmado: boolean) => {
      if (confirmado) {
        this.reiniciarValidacionCorreo();
        return;
      }

      this.restaurarEmailValidado();
    });
  }

  private confirmarCambioTelefono(nuevoTelefono: string): void {
    this.dialog.open(RegistroInformativoDialogComponent, {
      width: '420px',
      maxWidth: 'calc(100vw - 32px)',
      autoFocus: false,
      data: {
        type: 'warning',
        icon: 'error_outline',
        title: 'Cambiar teléfono',
        message: 'Si cambias el teléfono tendrás que validarlo nuevamente. ¿Deseas continuar?',
        showCancelButton: true,
        confirmText: 'Continuar',
        cancelText: 'Cancelar'
      }
    }).afterClosed().subscribe((confirmado: boolean) => {
      if (confirmado) {
        this.reiniciarValidacionTelefono();
        return;
      }

      this.restaurarTelefonoValidado();
    });
  }

  private restaurarEmailValidado(): void {
    this.restaurandoContacto = true;

    this.todoFormulario.get('Email')?.setValue(this.emailValidado, {
      emitEvent: true
    });

    setTimeout(() => {
      this.restaurandoContacto = false;
    });
  }

  private restaurarTelefonoValidado(): void {
    this.restaurandoContacto = true;
    this.sincronizarTelefonoVisualDesdeCompleto(this.telefonoValidado);

    this.todoFormulario.get('Telefono')?.setValue(this.telefonoValidado, {
      emitEvent: true
    });

    setTimeout(() => {
      this.restaurandoContacto = false;
    });
  }

  private abrirDialogoInformativo(
    type: 'info' | 'warning' | 'error' | 'success',
    title: string,
    message: string
  ): void {
    this.dialog.open(RegistroInformativoDialogComponent, {
      width: '420px',
      maxWidth: 'calc(100vw - 32px)',
      autoFocus: false,
      data: {
        type,
        title,
        message,
        actionText: 'Aceptar'
      }
    });
  }

  getError(controlName: string): string {
    const control = this.getControl(controlName);

    if (!control || !control.errors || !(control.touched || control.dirty)) {
      return '';
    }

    if (control.hasError('required')) {
      return 'El campo es obligatorio';
    }

    if (control.hasError('telefonoLocalIncompleto')) {
      return 'Ingresa los 10 dígitos del teléfono';
    }

    if (control.hasError('email')) {
      return 'El correo no tiene un formato válido';
    }

    if (control.hasError('pattern')) {
      return this.getPatternError(controlName);
    }

    if (control.hasError('minlength') || control.hasError('minlengthCustom')) {
      return 'El valor es demasiado corto';
    }

    if (control.hasError('maxlength') || control.hasError('maxlengthCustom')) {
      return 'El valor excede la longitud permitida';
    }

    if (control.hasError('exists') || control.hasError('customError')) {
      return this.validacionUsuario || 'El usuario no es válido';
    }

    if (control.hasError('formatoIncorrecto')) {
      return 'La contraseña tiene un formato incorrecto';
    }

    if (control.hasError('match')) {
      return 'Las contraseñas no coinciden';
    }

    return 'El campo no es válido';
  }

  private configurarValidacionUsuario(): void {
    const usuarioControl = this.todoFormulario.get('Usuario');

    if (!usuarioControl) {
      return;
    }

    this.subscriptions.add(
      usuarioControl.valueChanges
        .pipe(
          /*
          * Primero descarta emisiones idénticas.
          * Así no se activa pending para un valor que no será procesado.
          */
          distinctUntilChanged(),

          /*
          * Desde el momento en que cambia realmente el usuario,
          * se elimina el resultado anterior.
          */
          tap(() => {
            this.validacionUsuario = '';
            this.usuarioValido.pending = true;
            this.usuarioValido.is = false;
            this.limpiarErrorUsuarioContacto();

            this.limpiarErroresControl(usuarioControl, [
              'exists',
              'customError',
              'minlengthCustom',
              'maxlengthCustom'
            ]);
          }),

          /*
          * timer cumple la función del debounce.
          * Al estar dentro de switchMap, cualquier nuevo cambio
          * cancela inmediatamente tanto el timer como una petición
          * anterior que todavía esté en proceso.
          */
          switchMap((usuario: string | null) =>
            timer(1000).pipe(
              switchMap(() => {
                const valorUsuario = `${usuario || ''}`;

                if (!valorUsuario.length) {
                  this.usuarioValido.pending = false;
                  this.usuarioValido.is = false;
                  return EMPTY;
                }

                if (!/^[a-zA-Z0-9_]*$/.test(valorUsuario)) {
                  this.validacionUsuario =
                    'Solo se permiten letras, números y guion bajo.';

                  this.usuarioValido.pending = false;
                  this.usuarioValido.is = false;

                  usuarioControl.setErrors({
                    ...(usuarioControl.errors || {}),
                    pattern: true
                  });

                  return EMPTY;
                }

                if (valorUsuario.length < 4) {
                  this.validacionUsuario =
                    'El nombre de usuario debe tener al menos 4 caracteres.';

                  this.usuarioValido.pending = false;
                  this.usuarioValido.is = false;

                  usuarioControl.setErrors({
                    ...(usuarioControl.errors || {}),
                    minlengthCustom: true
                  });

                  return EMPTY;
                }

                if (valorUsuario.length > 8) {
                  this.validacionUsuario =
                    'El campo solo puede tener hasta 8 caracteres.';

                  this.usuarioValido.pending = false;
                  this.usuarioValido.is = false;

                  usuarioControl.setErrors({
                    ...(usuarioControl.errors || {}),
                    maxlengthCustom: true
                  });

                  return EMPTY;
                }

                if (!this.contrasenaVacia) {
                  this.validarContrasena(
                    this.todoFormulario.get('Password')?.value
                  );
                }

                return this.validarUsuario(valorUsuario);
              })
            )
          )
        )
        .subscribe((resultado: ResultadoValidacionUsuario) => {
          this.usuarioValido.pending = false;

          if (resultado.estado === 'valido') {
            this.usuarioValido.is = true;
            this.validacionUsuario = '';

            if (this.validandoCorreo || this.validandoTelefono) {
              this.actualizarUsuario = 'true';
            }

            this.limpiarErroresControl(usuarioControl, [
              'exists',
              'customError',
              'minlengthCustom',
              'maxlengthCustom',
              'pattern'
            ]);

            return;
          }

          this.usuarioValido.is = false;

          const esTimeout =
            resultado.error?.name === 'TimeoutError';

          if (esTimeout) {
            this.validacionUsuario =
              'La validación del usuario tardó demasiado. Intenta nuevamente.';

            usuarioControl.setErrors({
              ...(usuarioControl.errors || {}),
              customError: true
            });

            return;
          }

          if (resultado.estado === 'errorSisa') {
            this.validacionUsuario =
              resultado.error?.error?.Exception ||
              'La clave de usuario ya existe.';

            usuarioControl.setErrors({
              ...(usuarioControl.errors || {}),
              exists: true,
              customError:
                resultado.error?.error?.Exception || true
            });

            return;
          }

          this.validacionUsuario =
            resultado.error?.error?.Exception ||
            'Usuario inválido.';

          usuarioControl.setErrors({
            ...(usuarioControl.errors || {}),
            customError: true
          });
        })
    );
  }

  private configurarValidacionPassword(): void {
    const passwordControl = this.todoFormulario.get('Password');

    if (!passwordControl) {
      return;
    }

    this.subscriptions.add(
      passwordControl.valueChanges
        .pipe(
          tap(() => {
            this.validandoPassword = true;
            this.passwordValido = false;
          }),
          debounceTime(1000),
          distinctUntilChanged()
        )
        .subscribe((password: string) => {
          if (password && password.length > 0) {
            this.validarContrasena(password);
            return;
          }

          this.reiniciarValidacionesContrasena();
        })
    );
  }

  private configurarSincronizacionConfirmacionPassword(): void {
    const passwordControl = this.todoFormulario.get('Password');
    const confirmaPasswordControl = this.todoFormulario.get('ConfirmaPassword');

    if (!passwordControl || !confirmaPasswordControl) {
      return;
    }

    this.subscriptions.add(
      passwordControl.valueChanges.subscribe(() => {
        this.sincronizarErrorConfirmaPassword();
      })
    );

    this.subscriptions.add(
      confirmaPasswordControl.valueChanges.subscribe(() => {
        this.sincronizarErrorConfirmaPassword();
      })
    );
  }

  private sincronizarErrorConfirmaPassword(): void {
    const passwordControl = this.todoFormulario.get('Password');
    const confirmaPasswordControl = this.todoFormulario.get('ConfirmaPassword');

    if (!passwordControl || !confirmaPasswordControl) {
      return;
    }

    const password = `${passwordControl.value || ''}`;
    const confirmaPassword = `${confirmaPasswordControl.value || ''}`;

    if (!confirmaPassword) {
      this.limpiarErroresControl(confirmaPasswordControl, ['match']);
      return;
    }

    if (password !== confirmaPassword) {
      confirmaPasswordControl.setErrors({
        ...(confirmaPasswordControl.errors || {}),
        match: true
      });

      return;
    }

    this.limpiarErroresControl(confirmaPasswordControl, ['match']);
  }

  abrirErroresPassword(): void {
    const validaciones = this.passwordValidaciones.length
      ? this.passwordValidaciones
      : ['No fue posible obtener el detalle de las reglas de contraseña.'];

    this.dialog.open(RegistroInformativoDialogComponent, {
      width: '420px',
      maxWidth: 'calc(100vw - 32px)',
      autoFocus: false,
      data: {
        type: 'warning',
        icon: 'error_outline',
        title: 'Revisa tu contraseña',
        message: 'La contraseña debe cumplir con las siguientes condiciones:',
        messages: validaciones,
        actionText: 'Entendido'
      }
    });
  }

  mostrarIconoPasswordError(): boolean {
    const passwordControl = this.todoFormulario.get('Password');

    return !!passwordControl
      && passwordControl.hasError('formatoIncorrecto')
      && (passwordControl.touched || passwordControl.dirty);
  }

  mostrarIconoPasswordCorrecto(): boolean {
    const passwordControl = this.todoFormulario.get('Password');

    return !!passwordControl
      && !!passwordControl.value
      && passwordControl.valid
      && this.passwordValido
      && !this.validandoPassword
      && !this.generaErrorPasswordForm;
  }

  mostrarIconoConfirmaPasswordCorrecto(): boolean {
    const passwordControl = this.todoFormulario.get('Password');
    const confirmaPasswordControl = this.todoFormulario.get('ConfirmaPassword');

    const password = `${passwordControl?.value || ''}`;
    const confirmaPassword = `${confirmaPasswordControl?.value || ''}`;

    return !!password
      && !!confirmaPassword
      && password === confirmaPassword
      && this.passwordValido
      && !this.validandoPassword
      && !this.generaErrorPasswordForm
      && !confirmaPasswordControl?.errors;
  }

  abrirInfoUsuario(): void {
    const mensaje = this.validacionUsuario || this.getError('Usuario') || 'El usuario no es válido.';

    this.dialog.open(RegistroInformativoDialogComponent, {
      width: '420px',
      maxWidth: 'calc(100vw - 32px)',
      autoFocus: false,
      data: {
        type: 'error',
        icon: 'error_outline',
        title: 'Usuario no disponible',
        message: mensaje,
        actionText: 'Entendido'
      }
    });
  }

  abrirInfoAlias(): void {
    this.dialog.open(RegistroInformativoDialogComponent, {
      width: '720px',
      maxWidth: 'calc(100vw - 32px)',
      autoFocus: false,
      data: {
        type: 'info',
        icon: 'info',
        title: 'Alias o sobrenombre',
        message: 'El alias hace referencia a lo que verá al intentar iniciar sesión.',
        imageSrc: 'assets/img/registro/atlas-login-ejemplo.png',
        imageAlt: 'Ejemplo de alias al iniciar sesión',
        actionText: 'Entendido'
      }
    });
  }

  private cargarCatalogoPreguntas(): void {
    this.authService.catalogoPreguntas().subscribe({
      next: (resp) => {
        this.catPreguntas = Object.assign(resp);
      },
      error: () => {
        this.catPreguntas = [];
      }
    });
  }

  private validarUsuario(
    usuario: string
  ): Observable<ResultadoValidacionUsuario> {
    return this.authService
      .validaUsuario(usuario)
      .pipe(
        timeout(15000),

        switchMap(() =>
          this.authService
            .validaUsuarioSisa(usuario)
            .pipe(
              timeout(15000),

              map(
                (): ResultadoValidacionUsuario => ({
                  estado: 'valido'
                })
              ),

              catchError(error =>
                of<ResultadoValidacionUsuario>({
                  estado: 'errorSisa',
                  error
                })
              )
            )
        ),

        catchError(error =>
          of<ResultadoValidacionUsuario>({
            estado: 'errorUsuario',
            error
          })
        )
      );
  }

  private validarContrasena(password: string): void {
    if (this.contrasenaVacia) {
      this.reiniciarValidacionesContrasena();
      return;
    }

    const request = {
      password,
      usuario: this.todoFormulario.get('Usuario')?.value
    };

    this.adminService.postValidaContrasena(request).subscribe({
      next: (resp: IResponseValidaContrasena) => {
        const control = this.todoFormulario.get('Password');
        this.validandoPassword = false;

        if (resp?.datos?.length > 0) {
          this.generaErrorPasswordForm = true;
          this.passwordValido = false;

          control?.setErrors({
            ...(control.errors || {}),
            formatoIncorrecto: true
          });

          this.procesarErroresPassword(resp.datos);
          return;
        }

        this.generaErrorPasswordForm = false;
        this.passwordValido = true;
        this.passwordValidaciones = [];

        if (control) {
          this.limpiarErroresControl(control, ['formatoIncorrecto']);
        }

        this.sincronizarErrorConfirmaPassword();
      },
      error: (error) => {
        this.validandoPassword = false;
        this.passwordValido = false;
        this.generaErrorPasswordForm = true;

        const control = this.todoFormulario.get('Password');

        control?.setErrors({
          ...(control.errors || {}),
          formatoIncorrecto: true
        });

        this.passwordValidaciones = this.normalizarMensajesPassword(error?.error);
        this.sincronizarErrorConfirmaPassword();
        if (!this.passwordValidaciones.length) {
          this.passwordValidaciones = [this.obtenerMensajeErrorPassword(error)];
        }
      }
    });
  }

  private procesarErroresPassword(validaciones: any[]): void {
    this.passwordValidaciones = this.normalizarMensajesPassword(validaciones);
  }

  private normalizarMensajesPassword(validaciones: any): string[] {
    if (!validaciones) {
      return [];
    }

    if (typeof validaciones === 'string') {
      return [validaciones];
    }

    if (!Array.isArray(validaciones)) {
      return this.normalizarMensajesPassword([validaciones]);
    }

    return validaciones
      .map((validacion: any) => {
        if (typeof validacion === 'string') {
          return validacion;
        }

        return validacion.Descripcion
          || validacion.descripcion
          || validacion.Description
          || validacion.description
          || validacion.Exception
          || validacion.exception
          || validacion.Mensaje
          || validacion.mensaje
          || validacion.Message
          || validacion.message
          || validacion.password?.[0]
          || '';
      })
      .filter((mensaje: string) => !!mensaje && mensaje.trim().length > 0);
  }
  private obtenerMensajeErrorPassword(error: any): string {
    const errores = error?.error || [];

    if (!Array.isArray(errores) || errores.length === 0) {
      return 'Ups, se generó un error.';
    }

    const mensajes = errores
      .map((item: any) => item?.Visible ? item.Exception : item?.password?.[0])
      .filter(Boolean);

    return mensajes.join(' ') || 'Ups, se generó un error.';
  }

  private reiniciarValidacionesContrasena(): void {
    const control = this.todoFormulario.get('Password');

    this.generaErrorPasswordForm = false;
    this.validandoPassword = false;
    this.passwordValido = false;
    this.passwordValidaciones = [];

    if (control) {
      this.limpiarErroresControl(control, ['formatoIncorrecto']);
    }
  }

  private limpiarErroresControl(control: AbstractControl, errores: string[]): void {
    if (!control.errors) {
      return;
    }

    errores.forEach(errorKey => {
      if (control.errors?.[errorKey]) {
        delete control.errors[errorKey];
      }
    });

    if (Object.keys(control.errors).length === 0) {
      control.setErrors(null);
      return;
    }

    control.setErrors(control.errors);
  }

  private getControl(controlName: string): AbstractControl | null {
    return this.todoFormulario.get(controlName);
  }

  abrirErrorPassword(): void {
    if (this.mostrarIconoPasswordError()) {
      this.abrirErroresPassword();
      return;
    }

    this.abrirErrorCampo('Password');
  }

  abrirErrorCampo(controlName: string): void {
    const mensaje = this.getError(controlName)
      || this.obtenerMensajeErrorControl(controlName)
      || 'El campo no es válido.';

    this.dialog.open(RegistroInformativoDialogComponent, {
      width: '420px',
      maxWidth: 'calc(100vw - 32px)',
      autoFocus: false,
      data: {
        type: 'error',
        icon: 'error_outline',
        title: `${this.obtenerEtiquetaControl(controlName)} no válido`,
        message: mensaje,
        actionText: 'Entendido'
      }
    });
  }

  private getPatternError(controlName: string): string {
    switch (controlName) {
      case 'Usuario':
        return 'Solo se permiten letras, números y guion bajo.';
      case 'Cuenta':
        return 'Solo se aceptan números.';
      case 'Telefono':
        return 'Ingresa los 10 dígitos del teléfono.';
      case 'Email':
        return 'El correo no tiene un formato válido.';
      case 'RFC':
        return 'El RFC no tiene un formato válido.';
      default:
        return 'El formato no es válido.';
    }
  }

  get contrasenaVacia(): boolean {
    const password = this.todoFormulario.get('Password')?.value;

    return password === null || password === undefined || `${password}`.trim() === '';
  }

  private obtenerClavePais(pais: string): string {
    const paisNormalizado = this.normalizarTexto(pais);

    const clavesPais: { [key: string]: string } = {
      'estados unidos': 'US',
      'canada': 'CA',
      'mexico': 'MX',
      'brasil': 'BR',
      'argentina': 'AR',
      'colombia': 'CO',
      'chile': 'CL',
      'venezuela': 'VE',
      'peru': 'PE',
      'ecuador': 'EC',
      'cuba': 'CU',
      'bolivia': 'BO',
      'costa rica': 'CR',
      'panama': 'PA',
      'uruguay': 'UY',
      'espana': 'ES',
      'alemania': 'DE',
      'francia': 'FR',
      'italia': 'IT',
      'reino unido': 'GB',
      'rusia': 'RU',
      'ucrania': 'UA',
      'polonia': 'PL',
      'paises bajos': 'NL',
      'belgica': 'BE',
      'portugal': 'PT',
      'china': 'CN',
      'india': 'IN',
      'japon': 'JP',
      'corea del sur': 'KR',
      'australia': 'AU',
      'nueva zelanda': 'NZ'
    };

    return clavesPais[paisNormalizado] || pais.trim().substring(0, 2).toUpperCase();
  }

  private normalizarTexto(valor: string): string {
    return `${valor || ''}`
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

    get codigoPaisTelefonoSeleccionadoKey(): string {
    return this.getCodigoPaisTelefonoKey(this.codigoPaisTelefonoSeleccionado);
  }

  getCodigoPaisTelefonoKey(pais: CodigoPaisTelefono): string {
    if (!pais) {
      return '';
    }

    return `${pais.codigo}|${this.normalizarTexto(pais.pais)}`;
  }
}
